import MarkdownIt from 'markdown-it'
import DOMPurify from 'dompurify'

const ALLOWED_TAGS = [
  'h1',
  'h2',
  'h3',
  'h4',
  'h5',
  'h6',
  'blockquote',
  'p',
  'a',
  'ul',
  'ol',
  'nl',
  'li',
  'b',
  'i',
  'strong',
  'em',
  'strike',
  'code',
  'hr',
  'br',
  'div',
  'table',
  'thead',
  'caption',
  'tbody',
  'tr',
  'th',
  'td',
  'pre',
  'span',
  'img',
]

const ALLOWED_ATTR = ['class', 'style', 'href', 'target', 'src', 'alt', 'title']

const FORBID_TAGS = ['script', 'iframe', 'object', 'embed']

const FORBID_ATTR = ['onerror', 'onload', 'onclick', 'onmouseover']

export default defineNuxtPlugin(() => {
  const md = new MarkdownIt({ html: true, linkify: true, typographer: true })

  const renderMarkdown = (markdownText: string | undefined | null) => {
    if (!markdownText) return ''

    const formattedText = markdownText
      .replace(/\\n/g, '\n')
      .replace(/\\t/g, '\t')
      .replace(/\\r/g, '\r')
      .replace(/\\"/g, '"')

    const rawHtml = md.render(formattedText)

    if (typeof window === 'undefined') return rawHtml

    return DOMPurify.sanitize(rawHtml, { ALLOWED_TAGS, ALLOWED_ATTR, FORBID_TAGS, FORBID_ATTR })
  }

  return { provide: { md: renderMarkdown } }
})
